import React from 'react';
import { styled } from '@mui/material/styles';
import { InputLabel, Input, InputAdornment, FormControl, FormHelperText } from '@mui/material';
import theme from '../theme';

const StyledInput = styled(Input)({
    borderBottomColor: theme.palette.primary.main,
    '&:not(.Mui-disabled):hover::before': {
        borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused': {
        borderBottomColor: theme.palette.primary.main,
    },
});

const styles = {
    margin: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
};

const ErrorText = styled(FormHelperText)({
    color: theme.palette.error.main,
});

export default function InputWithAdornment(props) {
    return (
        <FormControl fullWidth style={styles.margin}>
            <InputLabel>{props.label}</InputLabel>
            <StyledInput
                value={props.value}
                onChange={props.onChange}
                startAdornment={<InputAdornment position="start">{props.adornment}</InputAdornment>}
                labelWidth={28}
                error={props.error}
                disabled={props.disabled}
                disableUnderline={props.transparent}
                {...props}
            />
            <ErrorText id="component-helper-text">{props.helperText}</ErrorText>
        </FormControl>
    );
}
